import React, { FC, Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

const InsuranceCompaniesListMF = React.lazy(() => import('riskManagementOnboarding/InsuranceCompaniesList'));

interface ICompaniesList {
  hideLabelText?: boolean;
  customColumnNumber?: number;
}

const InsuranceCompaniesList: FC<ICompaniesList> = () => (
  <ErrorBoundary fallbackRender={null}>
    <Suspense fallback={null}>
      <InsuranceCompaniesListMF hideLabelText customColumnNumber={4} />
    </Suspense>
  </ErrorBoundary>
);

export default InsuranceCompaniesList;
